<template>
  <div class="vacancies">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <!-- <div class="col-sm-12"> -->
                <div class="col">
                  <h3 class="page-title">Applications</h3>
                  <ul class="breadcrumb">
                    <li class="breadcrumb-item active">Application Feedback</li>
                  </ul>
                </div>
                </div>
              <!-- </div> -->
            </div>
          </div>
          <!-- /Page Header -->

          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body">
                  <div class="table-responsive">
                    <v-data-table
                      :headers="headers"
                      :items="applications"
                      sort-by=""
                      class="elevation-1"
                    >
                  <template v-slot:[`item.profile`]="{ item }">
                              <span>{{item.application.applicant.firstName + ' ' + item.application.applicant.lastName}}</span>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                              <button type="button" v-if="item.status != 1" class="btn btn-primary" @click="openFeedBack(item.id)">Give Feedback</button>
                  </template>
                </v-data-table>
                  </div>
                </div>
              </div>
            </div>
            <v-dialog v-model="feedbackDialog" max-width="500px">
              <div class="modal-content">
                <div class="modal-header">
                <h5 class="modal-title">FeedBack</h5>
                <button type="button" @click="closeFeedBack">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
                <div class="modal-body">
                  <div class="form-group">
                    <label>Note <span class="text-danger">*</span></label>
                    <textarea rows="4" class="form-control" v-model="app.note" />
                  </div>
                  <div class="form-group">
                    <label>Strength <span class="text-danger">*</span></label>
                    <textarea rows="4" class="form-control" v-model="app.strength" />
                  </div>
                  <div class="form-group">
                    <label>Weakness <span class="text-danger">*</span></label>
                    <textarea rows="4" class="form-control" v-model="app.weakness" />
                  </div>
                  <div class="form-group">
                    <label>Recommendation <span class="text-danger">*</span></label>
                    <p>After interviewing the candidate and considering the feedback, would you recommend we hire this candidate?</p>
                    <select class="form-control" v-model="app.recommendationStatus">
                      <option :value="2">Please Select </option>
                      <option :value="1">Yes, I recommend hiring this candidate</option>
                      <option :value="0">No, I do not recommend hiring this candidate</option>
                    </select>
                  </div>
                  <div class="modal-btn delete-action">
                    <div class="row">
                      <div class="col-6">
                        <a
                          class="btn btn-primary continue-btn"
                          @click="submitFeedBack()"
                          data-dismiss="modal"
                          >Submit</a
                        >
                      </div>
                      <div class="col-6">
                        <a
                          class="btn btn-primary cancel-btn"
                          @click="closeFeedBack()"
                          >Cancel</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </v-dialog>
          </div>
          <!-- /Page Content -->
        </div>
      </div>
      <!-- /Page Wrapper -->
    </div>
</template>
<script>
import LayoutHeader from '@/components/layouts/Header.vue'
import LayoutSidebar from '@/components/layouts/employeeSidebar.vue'
import { jobService } from '@/services/jobService';
import { authenticationService } from "@/services/authenticationService";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data () {
    return {
      headers: [
        { text: 'Interview Date', value: 'application.applicationInterviewScheduling.confirmedDate' },
        {
          text: 'Applicant Name',
          align: 'start',
          value: 'profile',
        },
        { text: 'Vacancy', value: 'application.vacancy.jobProfile.title' },
        { text: 'Interview Time', value: 'application.applicationInterviewScheduling.confirmedTime' },
        { text: '', value: 'actions', sortable: false },
      ],
      applications: [],
      app: {
        applicationInterviewerId: 0,
        strength: '',
        weakness: '',
        note: '',
        recommendationStatus: 2
      },
      user: authenticationService.currentUserValue,
      feedbackDialog: false
    }
  },
  mounted() {
    this.getAllApplications()
    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
  },
  methods: {
    openFeedBack(item) {
      this.app.applicationInterviewerId = item
      this.feedbackDialog = true
    },
    closeFeedBack() {
      this.app = {
        applicationInterviewerId: 0,
        strength: '',
        weakness: '',
        note: '',
        recommendationStatus: 0
      }
      this.feedbackDialog = false
    },
    getAllApplications() {
      jobService.getApplicationInterviewersByEmployee(this.user.employee.id)
      .then(
        p => {
          this.applications = p;
        }
      )
    },
    submitFeedBack(){
      if(!this.app.strength && !this.app.weakness && !this.app.note){
        this.error = 'All inputs are required'
        return
      }
      if(this.app.recommendationStatus == 2){
        this.error = "Please select recommendation"
        return 
      }
      jobService.createApplicationInterviewerFeedback(this.app)
      .then(
        p => {
          this.message = "Thank you for your feedback"
          jobService.getApplicationInterviewersByEmployee(this.user.employee.id)
      .then(
        p => {
          this.applications = p;
          this.closeFeedBack()
        }
      )
        }
      )
    }
    
  },
  name: "applications"
};
</script>



// WEBPACK FOOTER //
// src/components/applications/feedback.vue